import { externalRedirect } from '@americanexpress/one-app-ducks';
import ReactDOM from 'react-dom';
import { readUserSession } from '../../facade/readUserSession';
import { getAllowedLocales } from '../../facade/getAllowedLocale';
import { getOneLoginDomain, getLangPackSelector } from '../../selectors/selectors';
import { convertLocaleToUpperCase } from '../../helpers/helpers';

const requireAuthHub = ({ getState, dispatch }) => async (nextState, replace, callback) => {
  try {
    if (!global.BROWSER) {
      return callback();
    }
    const { params } = nextState;
    const paramsLocale = params?.locale?.toLowerCase();
    const state = getState();
    const oneLoginDomain = getOneLoginDomain(state);
    const languagePack = getLangPackSelector(state);
    const activeLocale = convertLocaleToUpperCase(paramsLocale);
    const isLoggedIn = await readUserSession(state);
    const locales = await getAllowedLocales(state);
    const isAllowedLocale = locales?.hubLocales?.[activeLocale] || false;

    // Check for un-minified version of ReactDOM and therefore the one-app-dev image (e0)
    if (!isLoggedIn && ReactDOM?.render?.name !== 'render') {
      /* redirect to last location entered by user instead of summaryURL everytime,
      avoiding redirection to wrong url issue */
      const loginUrl = `${oneLoginDomain}/${paramsLocale}/account/travel/login?DestPage=${encodeURIComponent(window.location.href)}`;
      dispatch(externalRedirect(loginUrl));
      return callback();
    }
    if (!isAllowedLocale && languagePack && languagePack && languagePack.links) {
      const { links: { switchFly } } = languagePack;
      dispatch(externalRedirect(switchFly));
    }
    return callback();
  } catch (error) {
    replace(`${nextState?.location?.pathname}/error`);
    return callback();
  }
};

export default requireAuthHub;
